import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStopSellIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.54044 3.12623C4.14992 2.7357 3.51675 2.7357 3.12623 3.12623C2.7357 3.51675 2.7357 4.14992 3.12623 4.54044L3.83333 3.83333L4.54044 3.12623ZM11.4596 12.8738C11.8501 13.2643 12.4832 13.2643 12.8738 12.8738C13.2643 12.4832 13.2643 11.8501 12.8738 11.4596L12.1667 12.1667L11.4596 12.8738ZM8 14V13C5.23858 13 3 10.7614 3 8H2H1C1 11.866 4.13401 15 8 15V14ZM2 8H3C3 5.23858 5.23858 3 8 3V2V1C4.13401 1 1 4.13401 1 8H2ZM8 2V3C10.7614 3 13 5.23858 13 8H14H15C15 4.13401 11.866 1 8 1V2ZM14 8H13C13 10.7614 10.7614 13 8 13V14V15C11.866 15 15 11.866 15 8H14ZM3.83333 3.83333L3.12623 4.54044L11.4596 12.8738L12.1667 12.1667L12.8738 11.4596L4.54044 3.12623L3.83333 3.83333Z",
		fill: "#082B42"
	})
});
export default SvgStopSellIcon;
